import { render, staticRenderFns } from "./BannerNotice.vue?vue&type=template&id=7207d202"
import script from "./BannerNotice.vue?vue&type=script&lang=js"
export * from "./BannerNotice.vue?vue&type=script&lang=js"
import style0 from "./BannerNotice.vue?vue&type=style&index=0&id=7207d202&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports